import type { MonospacePage, MonospacePageSection, MonospaceSpace } from '#layers/data-model';
import * as z from 'zod/v4-mini';
import { RStoreSchema } from '#imports';
import { nonEmptyString } from '#layers/base';

export const Space = RStoreSchema.withItemType<MonospaceSpace>().defineCollection({
	name: 'MonospaceSpace',
	scopeId: 'monospace-default',
	formSchema: {
		create: z.object({
			title: z.string().check(z.minLength(1)),
			icon: z.string(),
		}),
		update: z.partial(z.object({
			title: z.string().check(z.minLength(1)),
			icon: z.string(),
		})),
	},
	meta: {
		defaultFields: ['id', 'title', 'route', 'icon', 'sort'],
		useProjectSlug: true,
	},
});

export const Page = RStoreSchema.withItemType<MonospacePage>().defineCollection({
	name: 'MonospacePage',
	scopeId: 'monospace-default',
	formSchema: {
		create: z.object({
			title: nonEmptyString(),
		}),
		update: z.partial(z.object({
			title: nonEmptyString(),
			icon: z.string(),
			description: z.string(),
		})),
	},
	meta: {
		defaultFields: ['id', 'title', 'route', 'icon', 'sort', 'isFullWidth', 'isHidden', 'spaceId', 'sectionId', 'type', 'collectionId', 'intent', 'overridePage'],
		useProjectSlug: true,
		relationsWithConstraint: new Set(['space', 'section', 'collection']),
		connect: {
			collectionId: ['collection', 'id'],
		},
	},
});

export const PageSection = RStoreSchema.withItemType<MonospacePageSection>().defineCollection({
	name: 'MonospacePageSection',
	scopeId: 'monospace-default',
	formSchema: {
		create: z.object({
			title: z.string().check(z.minLength(1)),
		}),
		update: z.partial(z.object({
			title: z.string().check(z.minLength(1)),
		})),
	},
	meta: {
		defaultFields: ['id', 'title', 'sort', 'spaceId'],
		useProjectSlug: true,
		connect: {
			spaceId: ['space', 'id'],
		},
	},
});
